const TabBody = ({ children, prefix, name }) => {
  return (
    <div style={{ flex: 1, overflow: "auto", padding: "20px 24px" }}>
      <div className="tab-content" id={prefix + "-" + name + "-tabContent"}>
        {children}
      </div>
    </div>
  );
};

export default TabBody;
